var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"170px","width":"170px"}},[_c('a',{attrs:{"href":"/user-profile"}},[_c('img',{staticClass:"absolute bottom-0 right-0",attrs:{"src":require('@/images/game/buttons/button-exit.svg')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }